module.exports = __webpack_public_path__ + "img/side-btn.6866d157.svg";